import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const orderService = {
    create: async (data) => {
        try {
            const res = await axiosService.post(endPoints.order.base, data);

            return res;
        } catch (error) {
            throw error;
        }
    },
    getByCurrentUser: async () => {
        try {
            const res = await axiosService.get(endPoints.order.byCurrentUser);

            return res;
        } catch (error) {
            throw error;
        }
    },
    getFilteredByCurrentUser: async (params) => {
        try {
            const res = await axiosService.get(endPoints.order.byCurrentUser, {
                params,
            });

            return res;
        } catch (error) {
            throw error;
        }
    },
    getById: async (id) => {
        try {
            const res = await axiosService.get(`${endPoints.order.base}${id}/`);

            return res;
        } catch (error) {
            throw error;
        }
    }
}

export {
    orderService,
}
